import {HttpClient, HttpResponseMessage} from "aurelia-http-client";
import {autoinject} from 'aurelia-dependency-injection';

@autoinject
export class FileProcessor {

    constructor(private httpClient: HttpClient) {
        
    }


    getFileList(fileList: FileList): Array<File> {
        let returnValue: Array<File> = [];
        if (!fileList) {
            return returnValue;
        }
        for (let i = 0; i < fileList.length; i++) {
            returnValue.push(fileList.item(i));
        }

        return returnValue;

    }

    maxFileSizeInBytes: number = 30000000;
    maxFileSizeInMegs: number = 30;

    validateFileSize(file: File): boolean {
        if (file.size > this.maxFileSizeInBytes) {
            alert("Sorry, '" + file.name + "' has a file size of " + this.getMegsFromBytes(file.size) + " megs. \nThe max file size of "
                + this.maxFileSizeInMegs.toString() + " megs.");
            return false;
        }
        return true;
    }

    getMegsFromBytes(size: number) : number {
        return Math.round(size / 1000000);
    }


    //Do not use the Fetch Client as it doesn't support onprogress. The fetch client returns a promise of fail/success.
    upload(upload: any, parentGuid:string, callback) : Promise<HttpResponseMessage> {

        if (this.validateFileSize(upload)) {

            let formData = new FormData();

            //The name must match the parameter name on the Controller.
            formData.append("upload", upload);
            formData.append("createdDate", new Date().toISOString());
            formData.append("parentGuid", parentGuid);
            formData.append("lastModifiedDate", upload.lastModifiedDate.toISOString());

            return this.httpClient.createRequest("attachments/uploadnew")
                .asPost()
                .withContent(formData)
                .withProgressCallback((event) =>
                    callback(event, upload))
                .send();

        }
        
    }

   

    

}